var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875972 0.00128937C0.671659 0.000964165 0.473656 0.05896 0.316335 0.165211C0.227791 0.225041 0.154599 0.298524 0.100951 0.381445C0.0473029 0.464366 0.0142526 0.555098 0.00369302 0.648445C-0.00686652 0.741794 0.00527238 0.835922 0.0394142 0.92544C0.073556 1.01496 0.129029 1.09811 0.202658 1.17013L4.12012 4.99023L0.342568 8.81745C0.269933 8.89035 0.21569 8.97424 0.182958 9.06428C0.150227 9.15432 0.139652 9.24875 0.151841 9.34213C0.164029 9.43552 0.198742 9.52602 0.253983 9.60843C0.309224 9.69085 0.383905 9.76355 0.473733 9.82237C0.564207 9.88725 0.670158 9.93619 0.784938 9.96611C0.899718 9.99604 1.02085 10.0063 1.14073 9.99627C1.26061 9.98623 1.37665 9.9561 1.48156 9.90778C1.58648 9.85946 1.67801 9.79398 1.75041 9.71546L5.97392 5.43923C6.10253 5.3117 6.17284 5.15174 6.17284 4.98666C6.17284 4.82158 6.10253 4.66162 5.97392 4.53409L1.60175 0.257864C1.51403 0.171614 1.4026 0.103434 1.2765 0.0588551C1.15039 0.0142765 1.01318 -0.00544643 0.875972 0.00128937Z",
    fill: "#2E37A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right-icon.e3fb0c8e1fc7adcfef237039f6a7e5b1.svg";
export { ForwardRef as ReactComponent };